import { Box, IconButton, chakra, type IconButtonProps } from '@chakra-ui/react'

interface ToggleButtonProps extends IconButtonProps {
  isOpen: boolean
}

export const ToggleButton = (props: ToggleButtonProps) => {
  const { isOpen, ...iconButtonProps } = props
  return (
    <IconButton
      variant='unstyled'
      display='inline-flex'
      size='xs'
      icon={<ToggleIcon active={isOpen} />}
      {...iconButtonProps}
      alignSelf={'center'}
    />
  )
}

const ToggleIcon = (props: { active: boolean }) => {
  const { active } = props

  return (
    <Box
      color='brand.aubergine'
      className='group'
      data-active={active ? '' : undefined}
      as='span'
      display='block'
      w={6}
      h={6}
      pos='relative'
      aria-hidden
      pointerEvents='none'
    >
      <Bar
        top='0rem'
        _groupActive={{ top: '0.5625rem', left: '50%', w: '0' }}
      />
      <Bar top='0.5625rem' _groupActive={{ transform: 'rotate(45deg)' }} />
      <Bar top='0.5625rem' _groupActive={{ transform: 'rotate(-45deg)' }} />
      <Bar
        top='1.125rem'
        _groupActive={{ top: '0.5625rem', left: '50%', w: '0' }}
      />
    </Box>
  )
}

const Bar = chakra('span', {
  baseStyle: {
    display: 'block',
    pos: 'absolute',
    w: '1.25rem',
    h: '0.125rem',
    rounded: 'full',
    bg: 'currentcolor',
    mx: 'auto',
    insetStart: '0.125rem',
    transition: 'all 0.12s',
  },
})
